import API from 'vuex-requests/src/store/backends/API'

export default class MetaDataGuruBackend extends API {
  constructor (name = 'metadataguru', store, options = {}) {
    super(name, store, options)
    this.store = store
    this.baseUrl = process.env.METADATAGURU_API_ROOT
    this.headers = { 'Content-Type': 'application/json' }
  }
  resources () {
    return {
      lineitems: 'lineitems/',
      notes: 'v3/notes/',
      documents: 'v3/documents/'
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/backends/metadataguru.js